<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/plugins/agcharts']" appearance="plain" variant="neutral">&larr; Back to AG Charts</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>AgScatterChart</h1>
		</div>
		<p waBody="m" waColorText="quiet" waText>Convenience scatter chart component</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_755" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</wa-details>
		<wa-details open summary="Properties (2)">
			<table style="border-collapse:collapse;width:100%;">
				<thead>
					<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Property</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Type</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Default</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
					</tr>
				</thead>
				<tbody>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">xKey</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">String</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">–</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Data key for x-axis values</td>
					</tr>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">yKey</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">String</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">–</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Data key for y-axis values</td>
					</tr>
				</tbody>
			</table>
		</wa-details>
	</div>
</div>